/* eslint-disable */

export enum Icons {
	Phone = 0,
	Email = 1,
	
}
